"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = __importDefault(require("../title/index"));
const button_1 = __importStar(require("@app/routes/SpeechDevelopment/button"));
const smallHeader_1 = __importDefault(require("@components/smallHeader"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const Pagination_1 = require("@components/Pagination");
const exercise_1 = require("@app/components/container/exercise");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
// Generates initial state for the check buttons
const generateInitialState = (length) => {
    return Array.from({ length }, (_, index) => ({
        isCorrect: false,
        index: index + 1,
        isChecked: false
    }));
};
const DropContainerWrapper = styled_components_1.default.div `
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    align-items: self-start;
    justify-content: end;
    height: 100%;
    @media (max-width: 1200px) {
        justify-content: center;
    }
    @media (max-width: 700px) {
        flex-wrap: wrap-reverse;
    }
`;
const Description = styled_components_1.default.div `
    font-size: 30px;
    font-weight: bold;
    color: white;
    text-align: center;
    @media (max-width: 850px) {
        font-size: 18px;
        padding: 4px 15px;
    }
    @media (max-width: 540px) {
        font-size: 18px;
        padding: 3px 10px;
        font-weight: 700;
    }
`;
// Renamed styled component to avoid conflict with interface
const StyledWordItem = styled_components_1.default.div `
    margin: 12px;
    background: transparent;
    padding: 5px 20px;
    border: 1px dashed #6E76FB;
    border-radius: 25px;
    cursor: pointer;
    user-select: none;
    font-size: clamp(16px, 3vw, 60px);
    font-weight: 700;
    color: #6E76FB;
    line-height: 40px;
    font-family: Phenomena;
    transition: background-color 0.2s ease-in-out;

    ${(props) => props.isCorrect !== undefined && `
      border: ${props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45'};
      color: ${props.isCorrect ? '#3CB949' : '#FE2B45'};
  `}
    &:hover {
        background-color: #dcdcdc;
    }
    @media (max-width: 870px) {
        font-size: 30px;
        padding: 4px 15px;
        margin: 6px;
    }
    @media (max-width: 540px) {
        font-size: 25px;
        padding: 3px 10px;
    }
`;
const GroupContainer = styled_components_1.default.div `
    display: flex;
    margin: 16px;
    padding: 8px;
    flex-wrap: wrap;
    width: auto;
    background-color: #f9f9f9;
    border-radius: 8px;
`;
const ImageBox = styled_components_1.default.div `
    display: flex;
    justify-content: end;
    align-items: end;
    max-width: 100%;
`;
const Image = styled_components_1.default.img `
    width: 100%;
    height: auto;
    max-width: 350px;
`;
const Box = styled_components_1.default.div `
    display: flex;
    border-radius: 12px;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 80%;
    overflow: hidden;
    @media (max-width: 768px) {
        width: 90%;
        max-width: 400px;
    }
    @media (max-width: 700px) {
        flex-direction: column;
    }
    @media (max-height: 600px) {
        padding: 10px;
        max-height: 50%;
    }
`;
let infoRep = [];
// Word component with updated drag and drop hover logic
const Word = ({ word, index, moveWord }) => {
    const ref = (0, react_1.useRef)(null);
    const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)({
        type: 'WORD',
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const [, drop] = (0, react_dnd_1.useDrop)({
        accept: 'WORD',
        hover(draggedItem, monitor) {
            if (!ref.current)
                return;
            if (draggedItem.index === index)
                return;
            const boundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleX = (boundingRect.right - boundingRect.left) / 2;
            const hoverMiddleY = (boundingRect.bottom - boundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset)
                return;
            const mouseX = clientOffset.x;
            const mouseY = clientOffset.y;
            // Determine dominant direction based on pointer position relative to the target's center
            const deltaX = Math.abs(mouseX - (boundingRect.left + hoverMiddleX));
            const deltaY = Math.abs(mouseY - (boundingRect.top + hoverMiddleY));
            if (deltaX > deltaY) {
                // Horizontal movement is dominant
                if (draggedItem.index < index && mouseX > boundingRect.left + hoverMiddleX) {
                    moveWord(draggedItem.index, index);
                    draggedItem.index = index;
                }
                else if (draggedItem.index > index && mouseX < boundingRect.left + hoverMiddleX) {
                    moveWord(draggedItem.index, index);
                    draggedItem.index = index;
                }
            }
            else {
                // Vertical movement is dominant
                if (draggedItem.index < index && mouseY > boundingRect.top + hoverMiddleY) {
                    moveWord(draggedItem.index, index);
                    draggedItem.index = index;
                }
                else if (draggedItem.index > index && mouseY < boundingRect.top + hoverMiddleY) {
                    moveWord(draggedItem.index, index);
                    draggedItem.index = index;
                }
            }
        }
    });
    drag(drop(ref));
    return (react_1.default.createElement(StyledWordItem, { ref: ref, isCorrect: word === null || word === void 0 ? void 0 : word.isCorrect, style: { opacity: isDragging ? 0.5 : 1 } }, word.word));
};
const Group = ({ group, words, moveWord }) => (react_1.default.createElement(GroupContainer, null, words.map((word, index) => (react_1.default.createElement(Word, { key: word.word, word: word, index: index, moveWord: moveWord, groupIndex: group - 1 })))));
const groupAndSortItems = (items) => {
    const grouped = items.reduce((acc, item) => {
        if (!acc[item.group])
            acc[item.group] = [];
        acc[item.group].push(item);
        return acc;
    }, {});
    return Object.keys(grouped).map(key => grouped[Number(key)]);
};
const Text_7_5 = ({ response, description, langId }) => {
    var _a, _b, _c;
    const [words, setWords] = (0, react_1.useState)([]);
    const [intialWords, setIntialWords] = (0, react_1.useState)([]);
    const [currentWord, setCurrentWord] = (0, react_1.useState)([]);
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(0);
    const [wrongAnswerCount, setWrongAnswerCount] = (0, react_1.useState)(0);
    const [title, setTitle] = (0, react_1.useState)('');
    const [images, setImages] = (0, react_1.useState)(null);
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(generateInitialState(10));
    const windowWidth = (0, useWindowWidrh_1.default)();
    const getLabel = () => {
        if (+langId === 1) {
            return "Проверить";
        }
        return "Check";
    };
    const handleAddCoin = () => {
        addCoin(3, 5);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (response) {
            setTitle((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title);
            const sortedWords = groupAndSortItems(response === null || response === void 0 ? void 0 : response.form);
            setWords(sortedWords);
            setCurrentIndex(0);
            setIntialWords(sortedWords);
            setCurrentWord([sortedWords[0]]);
            setImages(response === null || response === void 0 ? void 0 : response.images);
            // @ts-ignore
            infoRep = [...infoRep, { rep_id: (_b = words[0]) === null || _b === void 0 ? void 0 : _b.id, category_name: '', system_time: '', startTime: Date.now() }];
            setCheckButtons(generateInitialState(sortedWords.length));
        }
    }, [response]);
    const checkSentence = () => {
        const checkCorrectSubArray = (subArray) => {
            const groupMap = new Map();
            subArray.forEach((word) => {
                if (!groupMap.has(word.group)) {
                    groupMap.set(word.group, []);
                }
                groupMap.get(word.group).push(word);
            });
            if (groupMap.size === 1) {
                // Validate correct order
                return subArray.map((word, index) => (Object.assign(Object.assign({}, word), { isCorrect: (word === null || word === void 0 ? void 0 : word.order) === index + 1 })));
            }
            else {
                return subArray.map((word) => (Object.assign(Object.assign({}, word), { isCorrect: false })));
            }
        };
        const updatedGroup = checkCorrectSubArray(words[currentIndex]);
        const updatedWords = words.map((group, index) => index === currentIndex ? updatedGroup : group);
        setWords(updatedWords);
        setCurrentWord([updatedGroup]);
        const isAllCorrect = updatedGroup.every((word) => word.isCorrect);
        if (isAllCorrect) {
            handleAddCoin();
            audioPlayer_1.audioPlayer.playAudio(audioPathNames_1.AudioPathNames.Correct);
            const nextIndex = Math.min(currentIndex + 1, words.length - 1);
            setTimeout(() => {
                setCurrentIndex(nextIndex);
                setCurrentWord([updatedWords[nextIndex]]);
                setWrongAnswerCount(0);
            }, 7000);
        }
        else if (wrongAnswerCount >= 2) {
            const nextIndex = Math.min(currentIndex + 1, words.length - 1);
            setCurrentIndex(nextIndex);
            setCurrentWord([updatedWords[nextIndex]]);
            setWrongAnswerCount(0);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio('x', +langId === 1 ? 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/Russian-error-318.mp3' : 'https://d9fvxjfzq4088.cloudfront.net/sound_errors/English-error-318.mp3');
            setWrongAnswerCount((prev) => prev + 1);
        }
        return isAllCorrect;
    };
    const handleCheckButtonClick = () => {
        const isChecked = checkSentence();
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1) {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                return prevButtons;
            }
            return prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        if (wrongAnswerCount === 2 || isChecked) {
                            // @ts-ignore
                            // sendInfoReport(infoRep,response?.number || response?.id, window.userId, [])
                            // @ts-ignore
                            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                        }
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: isChecked || (!isChecked && wrongAnswerCount === 2), isCorrect: (wrongAnswerCount === 2 || isChecked) ? isChecked : undefined });
                }
                return button;
            });
        });
    };
    const moveWord = (fromIndex, toIndex) => {
        const updatedGroup = [...words[currentIndex]];
        const [movedWord] = updatedGroup.splice(fromIndex, 1);
        updatedGroup.splice(toIndex, 0, movedWord);
        setWords(words.map((group, index) => (index === currentIndex ? updatedGroup : group)));
        setCurrentWord([updatedGroup]);
    };
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        windowWidth <= 1200 ? (react_1.default.createElement(smallHeader_1.default, { exerciseName: ((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.title) || "Составление фраз и предложений" })) : null,
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            windowWidth <= 1200 ? null : (react_1.default.createElement(index_1.default, { text: ((_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.title) || "Составление фраз и предложений" })),
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(Description, null, description || ''),
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(Box, null,
                        react_1.default.createElement(Group, { group: currentIndex + 1, words: currentWord[0] || [], moveWord: moveWord }),
                        react_1.default.createElement(ImageBox, null,
                            react_1.default.createElement(Image, { src: `${(_c = images === null || images === void 0 ? void 0 : images[currentIndex]) === null || _c === void 0 ? void 0 : _c.hint}`, alt: `Image ${currentIndex + 1}` }))),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => (react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked
                        ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)"
                        : !item.isCorrect && item.isChecked
                            ? "#FF1431"
                            : null }))))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(button_1.default, { isShowShadow: false, label: getLabel(), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = Text_7_5;
